export const AlertRuleVariant = {
  AirQuality: "airQuality",
  HighHumidity: "highHumidity",
  LowHumidity: "lowHumidity",
  HighTemperature: "highTemperature",
  LowTemperature: "lowTemperature",
  CoolingEfficiency: "coolingEfficiency",
  HeatingEfficiency: "heatingEfficiency",
} as const

export type AlertRuleVariant = (typeof AlertRuleVariant)[keyof typeof AlertRuleVariant]

export interface AlertRuleDraft {
  thresholdValue: string
  thresholdUnit?: string
  durationValue: string
  durationUnit: string
}
